<template src="./index.html"></template>
<script>
import data from './data.js';
import config from '../../../../configHttp.js';
import { MainFunction } from '@/components/util/Function/MainFunction';
import { page, summary, batchAcquire, screenshotContent } from '@/api/declarationArchive';

export default {
  name: 'DeclarationArchive',
  data: function() {
    return {
      searchdata: Object.assign({}, data.searchdata),
      searchlist: data.searchlist,
      headData: data.headData.slice(),
      outlist: data.optionalHeadData.slice(),
      shaidiag: false,
      tableData: [],
      pagination: Object.assign({}, data.pagination),
      tableKey: 0,
      previewVisible: false,
      previewUrl: '',
      currentRow: null,
      selectedRows: [],
      summaryData: { total: 0, success: 0, pending: 0 }
    };
  },
  mounted: function() {
    this.searchdata.period = MainFunction.$getdefultMonth();
    this.initTableData();
  },
  methods: {
    submitSearch: function() {
      this.pagination.pageNum = 1;
      this.tableKey += 1;
      this.initTableData();
    },
    closeshaidiag: function() {
      this.shaidiag = false;
    },
    confirmfilter: function(e) {
      this.headData = e.chooselist;
      this.outlist = e.nochooselist;
      this.shaidiag = false;
      this.tableKey += 1;
    },
    searchByArchiveStatus: function(status) {
      this.searchdata.archiveStatus = status.slice();
      this.submitSearch();
    },
    isArchiveStatusSelected: function(statuses) {
      var selected = Array.isArray(this.searchdata.archiveStatus) ? this.searchdata.archiveStatus : [];
      return selected.length === statuses.length && statuses.every(function(status) { return selected.indexOf(status) !== -1; });
    },
    selectSizeChange: function(e) {
      this.pagination.pageSize = e;
      this.initTableData();
    },
    selectCurrentChange: function(e) {
      this.pagination.pageNum = e;
      this.initTableData();
    },
    selectionChange: function(rows) {
      this.selectedRows = rows || [];
    },
    initTableData: function() {
      var query = Object.assign({}, this.searchdata, {
        archiveStatus: (Array.isArray(this.searchdata.archiveStatus) ? this.searchdata.archiveStatus : []).join(',')
      });
      var params = Object.assign({}, query, {
        current: this.pagination.pageNum,
        size: this.pagination.pageSize
      });
      page(params).then((res) => {
        if (res.data.code == 1) {
          this.tableData = (res.data.data.records || []).map((row) => {
            row.declarationCycle = this.declarationCycleFormat(row.declarationCycle);
            return row;
          });
          this.pagination.total = res.data.data.total;
          this.pagination.pageNum = res.data.data.current;
          this.pagination.pageSize = res.data.data.size;
          this.selectedRows = [];
        } else {
          this.$message.error(res.data.msg);
        }
      }).catch(() => this.$message.error('申报归档数据加载失败'));
      summary({ period: query.period }).then((res) => {
        if (res.data.code == 1) {
          var value = res.data.data || {};
          this.summaryData = {
            total: value.total || 0,
            success: value.success || 0,
            pending: value.pending || 0
          };
        }
      });
    },
    selectedCompanyIds: function() {
      return this.selectedRows.map(function(row) { return row.companyId; });
    },
    declarationCycleFormat: function(code) {
      if (code === '1') return '月报';
      if (code === '2') return '季报';
      return code || '';
    },
    screenshotTypeName: function(code) {
      var names = {
        '1': '待办事项',
        '2': '未申报查询',
        '3': '申报信息查询',
        '4': '财务报表信息查询',
        '5': '居民企业所得税月（季）度申报',
        '6': '增值税及附加税（一般纳税人）',
        '7': '增值税及附加税（小规模纳税人）',
        '8': '企业会计准则（未执行新准则）',
        '9': '小企业会计准则',
        '10': '企业会计准则（已执行新准则）',
        '11': '企业会计制度',
        '12': '民间非营利组织会计制度',
        '13': '印花税',
        '14': '城镇土地使用税',
        '15': '环境保护税',
        '16': '契税',
        '17': '房产税',
        '18': '残保金',
        '19': '文化事业建设费',
        '20': '通用申报',
        '21': '消费税及附加税'
      };
      return names[code] || code || '';
    },
    batchAcquire: function() {
      var companyIds = this.selectedCompanyIds();
      if (!companyIds.length) {
        this.$message.warning('请选择需要批量获取截图的公司');
        return;
      }
      batchAcquire({ companyIds: companyIds, period: this.searchdata.period }).then((res) => {
        if (res.data.code == 1) {
          var result = res.data.data || {};
          var successCount = result.successCount || 0;
          var failureCount = result.failureCount || 0;
          if (failureCount > 0) {
            var selectedCodeMap = {};
            this.selectedRows.forEach(function(row) {
              selectedCodeMap[row.companyId] = row.companyCode;
            });
            var failureDetails = (result.records || []).filter(function(item) {
              return item.success !== true;
            }).map(function(item) {
              var companyCode = item.companyCode || selectedCodeMap[item.companyId] || '';
              return companyCode + (item.message ? '（' + item.message + '）' : '');
            }).filter(Boolean);
            var message = '成功提交 ' + successCount + ' 家，失败 ' + failureCount + ' 家';
            if (failureDetails.length) {
              message += '：' + failureDetails.join('、');
            }
            this.$message.warning(message);
          } else {
            var companyCodes = (result.records || []).map(function(item) {
              return item.companyCode || '';
            }).filter(Boolean);
            var successMessage = '已提交 ' + successCount + ' 家公司的截图获取任务';
            if (companyCodes.length) {
              successMessage += '：' + companyCodes.join('、');
            }
            this.$message.success(successMessage);
          }
        } else {
          this.$message.error(res.data.msg);
        }
      }).catch(() => this.$message.error('批量获取任务提交失败'));
    },
    batchDownload: function() {
      var companyIds = this.selectedCompanyIds();
      if (!companyIds.length) {
        this.$message.warning('请选择需要下载截图的公司');
        return;
      }
      this.$downloadcommon({
        downUrl: config.baseURL + '/declarationArchive/batchDownload',
        typeObj: {
          toForm: false,
          fileName: this.searchdata.period + '_申报归档截图',
          fileType: 'zip'
        },
        params: { companyIds: companyIds, period: this.searchdata.period }
      });
    },
    getScreenshot: function(row, type) {
      return row && row.screenshots ? row.screenshots[type] || null : null;
    },
    isScreenshotSuccess: function(row, type) {
      var record = this.getScreenshot(row, type);
      return !!record && record.screenshotStatus === '获取成功';
    },
    screenshotIconClass: function(row, type) {
      var record = this.getScreenshot(row, type);
      if (!record) return '';
      if (record.screenshotStatus === '获取成功') return 'el-icon-circle-check status-icon status-success';
      if (record.screenshotStatus === '获取异常') return 'el-icon-circle-close status-icon status-error';
      return 'el-icon-time status-icon status-waiting';
    },
    screenshotTimeText: function(row, type) {
      var record = this.getScreenshot(row, type);
      return record && record.screenshotTime ? record.screenshotTime : (record ? '——' : '');
    },
    viewScreenshot: function(row, type) {
      if (!this.isScreenshotSuccess(row, type)) return;
      var record = this.getScreenshot(row, type);
      screenshotContent({
        companyId: row.companyId,
        period: this.searchdata.period,
        screenshotType: type
      }).then((blob) => {
        this.clearPreviewUrl();
        this.currentRow = Object.assign({}, row, {
          screenshotType: type,
          screenshotStatus: record.screenshotStatus,
          screenshotTime: record.screenshotTime
        });
        this.previewUrl = URL.createObjectURL(blob);
        this.previewVisible = true;
      }).catch(() => this.$message.error('截图内容加载失败'));
    },
    getScreenshotUrl: function(row) {
      return row ? this.previewUrl : '';
    },
    clearPreviewUrl: function() {
      if (this.previewUrl && this.previewUrl.indexOf('blob:') === 0) URL.revokeObjectURL(this.previewUrl);
      this.previewUrl = '';
    },
    clearPreview: function() {
      this.clearPreviewUrl();
      this.currentRow = null;
    },
    archiveStatusClass: function(status) {
      if (status === '归档成功') return 'archive-status-success';
      if (status === '归档异常') return 'archive-status-error';
      if (status === '归档中') return 'archive-status-progress';
      return 'archive-status-pending';
    },
    formatPeriod: function(period) {
      return period ? period.slice(0, 4) + '年' + Number(period.slice(4)) + '期' : '';
    }
  }
};
</script>
<style lang="less" src="./index.less"></style>
